import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import setUiMessage from '../../Utilities/Tostify';
import { post } from '../Auths/AuthToken';
import ConfirmDialog from '../../Utilities/ConfirmDialog';
import { useSelector } from 'react-redux';
import Button from '../Button';

function DocsNotePopup({
  handleCloseDocsNote,
  docsNote,
  docId,
  handleUpdateDocsNote,
}) {
  const { user } = useSelector((state) => state.auth);
  const [textArea, setTextArea] = useState('');
  const [noteId, setNoteId] = useState('');

  const [showDialog, setShowDialog] = useState(false);

  const editDeleteNote = (id) => {
    const noteArr = docsNote.find((item, i) => item?.id === id);
    setTextArea(noteArr?.userComment);
    setNoteId(id);
  };

  const saveUserComment = async () => {
    try {
      if (!textArea) {
        setUiMessage('war', 'Please write note...');
      } else {
        const response = await post(
          'api/patient/ManagePatientDocument/saveUserCommentInfo',
          {
            userComment: textArea,
            docId: docId,
            loginUserId: user?.id,
          }
        );
        if (response?.status === 200) {
          response?.data?.userDataArr &&
            handleUpdateDocsNote(response?.data?.userDataArr);
          setTextArea('');
          setUiMessage('suc', 'Note has been save successfully.');
        }
      }
    } catch (err) {
      setUiMessage('err', err.message);
    }
  };

  const cancelUserNote = () => {
    setNoteId('');
    setTextArea('');
  };

  const updateUserNote = async (noteId) => {
    try {
      if (!textArea) {
        setUiMessage('war', 'Please write note...');
      } else {
        const response = await post(
          'api/patient/ManagePatientDocument/updateNote',
          {
            userCommentAdd: textArea,
            noteId: noteId,
            docId: docId,
            loginUserId: user?.id,
          }
        );
        if (response?.status === 200) {
          response?.data?.userDataArr &&
            handleUpdateDocsNote(response?.data?.userDataArr);
          setTextArea('');
          setUiMessage('suc', 'Note has been updated successfully.');
          cancelUserNote();
        }
      }
    } catch (err) {
      setUiMessage('err', err.message);
    }
  };

  const handleDeleteNoteConfirm = async (noteId) => {
    try {
      const response = await post(
        'api/patient/ManagePatientDocument/editDeleteNote',
        {
          act: 'delete',
          noteId: noteId,
          docId: docId,
        }
      );
      if (response?.status === 200) {
        response?.data?.userDataArr &&
          handleUpdateDocsNote(response?.data?.userDataArr);
        setUiMessage('suc', 'Note has been delete successfully.');
        setShowDialog(false);
      }
    } catch (err) {
      setUiMessage('err', err.message);
    }
  };

  return (
    <div className="modalBackground">
      <div
        className="user-comment-docu-popup-main-container"
        style={{ position: 'unset' }}
      >
        <div className="identity-header">
          <span className="Emergency-header-heading-text">User Note:</span>
          <span className="body-header-text-freespace"> &nbsp; </span>
          <Button variant="circle" onClick={handleCloseDocsNote}>
            X
          </Button>
        </div>
        <div className="width100 form-bg-color">
          <div className="user-comment-doc-text-box">
            <textarea
              rows="4"
              cols="40"
              className="user-comment-doc-text-box-element"
              id="userCommentAdd"
              maxLength="256"
              placeholder="Write here..."
              value={textArea || ''}
              onChange={(e) => setTextArea(e.target.value)}
            ></textarea>
          </div>
          <div className="post-comment-button-row">
            Max-allowed character {256 - (textArea && textArea.length)}
            {noteId ? (
              <div className="flex-sec gap10">
                <Button variant="outline" onClick={cancelUserNote}>
                  Cancel
                </Button>
                <Button
                  variant="primary"
                  onClick={() => updateUserNote(noteId)}
                >
                  Update
                </Button>
              </div>
            ) : (
              <Button variant="primary" onClick={saveUserComment}>
                Record
              </Button>
            )}
          </div>
        </div>
        <div className="user-comment-block">
          {docsNote &&
            docsNote.map((note, i) => (
              <div key={i} className="user-comment-box">
                <div className="data-row">
                  <div className="left">
                    <span className="doc-user-name">
                      {`${note?.userName}`}:
                    </span>
                    <span className="doc-comment-date">{`${note?.date}`}</span>
                  </div>
                  <div className="edit-del hoverLink">
                    <Link
                      className="edtn-button"
                      onClick={() => editDeleteNote(note?.id)}
                    >
                      Change
                    </Link>
                    &nbsp;|&nbsp;
                    <Link
                      onClick={() => {
                        setShowDialog(true);
                        setNoteId(note?.id);
                        setTextArea('');
                      }}
                    >
                      Delete
                    </Link>
                  </div>
                </div>
                <div className="data-row">
                  <span className="doc-user-comment">
                    {`${note?.userComment}`}
                  </span>
                </div>
              </div>
            ))}
        </div>
        <div
          className="lwidth100 flex-sec justify-end item-center"
          style={{ padding: '5px 10px' }}
        >
          <Button variant="outline" onClick={handleCloseDocsNote}>
            Close
          </Button>
        </div>
      </div>
      {showDialog && (
        <ConfirmDialog
          title={`Patient Notes`}
          bodytext={`Do you really want to delete the selected note..?`}
          closeDialog={() => setShowDialog(false)}
          successDialog={handleDeleteNoteConfirm}
          sucPrams={noteId}
        />
      )}
    </div>
  );
}

export default DocsNotePopup;
